<template>
  <div class="bigBox">
    <!--    导航-->
    <div class="navigation" id="navigationA">
      <div class="left">
        <img src="../assets/logo_text.png" alt="">
      </div>
      <div class="right">
        <div class="item" v-for="(item,index) in navigationList" :key="index" :class="{'selected': selected==index}"
             @click="changeSe(index,item.sign)">{{ item.name }}
        </div>
      </div>
    </div>
    <!--    轮播图-->
    <swiper-one></swiper-one>
    <!--    数据化转型解决方案/公司介绍-->
    <div class="digitization" id="digitization">
      <div class="title">
        <div class="en">PROVIDER</div>
        <div class="zh">数字化转型解决方案提供商</div>
      </div>
      <div class="content">
        <div class="items" @mouseover="mouseover(1)" @mouseleave="mouseout()">
          <img class="borderImg" v-if="mouseValue==1" :src="require('@/assets/border.png')" alt="">
          <img class="img1 imgIcon" :src="require('@/assets/QYXX.png')" alt="">
          <div class="cont w240">
            <span>芸券科技(上海)有限公司,成立于2018年,注册资金3000万元,是一家集专业的计算机软件开发、系统集成运维及信息化解决方案为一体的提供商。</span>
          </div>
        </div>
        <div class="items" @mouseover="mouseover(2)" @mouseleave="mouseout()">
          <img class="borderImg2" v-if="mouseValue==2" :src="require('@/assets/border.png')" alt="">
          <img class="img2 imgIcon" :src="require('@/assets/KJ.png')" alt="">
          <div class="cont w260">
            <span>经过多年的深耕与发展,拥有自有科技软件产品和行业解决方案,形成了自有产品研发和进化体系,为金融、交通、互联网等行业提供专业的科技服务。</span>
          </div>
        </div>
        <div class="items" @mouseover="mouseover(3)" @mouseleave="mouseout()">
          <img class="borderImg" v-if="mouseValue==3" :src="require('@/assets/border.png')" alt="">
          <img class="img3 imgIcon" :src="require('@/assets/RXK.png')" alt="">
          <div class="cont w240">
            <span>同时,芸券科技也聚焦于为各行各业输送优质人才,在技术开发领域培养众多能力强、技术好的专业人员,为客户提供优质的人力资源服务。</span>
          </div>
        </div>
      </div>
    </div>
    <!--    解决方案部份-->
    <div class="solutions" id="solutions">
      <div class="oneBox">
        <div class="title">
          <div class="en">RPA</div>
          <div class="zh">机器人流程自动化</div>
        </div>
        <div class="content">
          <img src="../assets/Flat_MacBook_2.png" alt="" class="img_MacBook">
          <div class="bankfinancial Lfetto" v-if="solutionsShow">
            <div class="tit">机器人流程自动化（RPA）</div>
            <p>机器人流程自动化（RPA）是一种软件技术，可轻松创建、部署和管理软件机器人，模拟人类行为，与数字系统和软件进行互动。 软件机器人可像人类一样工作，比如理解屏幕上的内容、正确完成按键、系统导航、识别和提取数据，以及完成一系列的既定行为。
</p>
            <!--          <div class="cont">重点行业应用开发（SaaS、PaaS、CRM、银行核心系统、监管报送平台、系统搭建、人工智能助理）</div>-->
            <!--          <div class="cont twoLine">大数据平台开发、商业智能、ERP云平台、智能终端、产品化解决方案</div>-->
          </div>
          <div class="internet rightTo" v-if="solutionsShow">
            <div class="tit">RPA应用案例</div>
            <div class="tit_t">交通（港口 / 航运） </div>
            <ul>
              <li>智能自动化通关</li>
              <li>计费业务自动化</li>
            </ul>
            <div class="tit_t">金融 / 财务 </div>
            <ul>
              <li>报表催收自动化</li>
              <li>财务流程自动化</li>
            </ul>
            <div class="tit_t">政府 </div>
            <ul>
              <li>人力资源流程自动化</li>
              <li>采购自动化</li>
            </ul>
          </div>
          <!-- <div class="servicelife  rightTo2" v-if="solutionsShow">
            <div class="tit">生活服务</div>
            <div class="flex">
              <ul>
                <li>券集宝系统</li>
                <li>玩味卡系统</li>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
      <div class="Rpa_chunk">
        <div class="title">RPA操作平台</div>
        <div class="Rpa_img"></div>
      </div>
      <!-- <div class="TwoBox">
        <div class="items" v-for="item in solutionArr" :style="{backgroundImage:'url('+item.img+')'}" :key="item.id" @mouseover.self="mouseoverSol(item)" @mouseleave.self="mouseoutSol(item)">
          <div class="itemText" v-if="item.show">{{item.text}}</div>
        </div>
      </div> -->
    </div>
    <!--    人力资源服务-->
    <div class="outsourcing" id="outsourcing">
      <div class="title">
        <div class="en">MANPOWER</div>
        <div class="zh">人力资源服务</div>
      </div>
      <!--      人力资源服务轮播图-->
      <swiper-three></swiper-three>
    </div>
    <!--    集成与运维-->
    <div class="operation" id="operation">
      <div class="title">
        <div class="en">OPERATION</div>
        <div class="zh">集成与运维</div>
      </div>
      <div class="content">
        <div class="left">
          <div class="item" :class="{'noborder': item.id==3,'hoverItem': item.id==hoverId}"
               @mouseover="mouseOver(item.id)" @mouseout="mouseOut" v-for="item in OPSList" :key="item.id">
            <img class="itemImg" :src="item.icon" alt="">
            <div class="itemText">
              <div class="titlei">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="../assets/computer.jpg" alt="">
        </div>
      </div>
    </div>
    <!--    联系我们-->
    <div class="contactus" id="contactus">
      <div class="title">
        <div class="en">CONTACT US</div>
        <div class="zh">联系我们</div>
      </div>
      <div class="content">
        <img src="../assets/map.png" alt="">
        <div class="rightBox">
          <div class="Name">联系电话：</div>
          <div class="value">021-52833062</div>
          <div class="Name">联系邮箱：</div>
          <div class="value">13917318180@139.com</div>
          <div class="Name">联系地址：</div>
          <div class="value">上海市长宁区通协路268号A807</div>
        </div>
      </div>
    </div>
    <!--    footer-->
    <div class="footer" :class="{'paddingCalc':isMobiel}">
      <a href=" https://beian.miit.gov.cn" target="_blank">
        &copy; 版权所有：芸券科技（上海）有限公司
        <span class="hao">沪ICP备18031787号</span>
      </a>
    </div>
  </div>
</template>

<script>
import swiperOne from "./components/swiperOne";
import swiperThree from "./components/swiperThree";

export default {
  name: "Home",
  components: {
    swiperOne,
    swiperThree
  },
  data() {
    return {
      isMobiel: false,
      navigationList: [
        {name: '网站首页', sign: 'navigationA'},
        {name: '公司介绍', sign: 'digitization'},
        {name: '机器人自动化', sign: 'solutions'},
        {name: '人力资源服务', sign: 'outsourcing'},
        {name: '集成与运维', sign: 'operation'},
        {name: '联系我们', sign: 'contactus'},
      ],
      selected: 0,
      mouseValue: null,
      solutionsShow: false, // 解决方案显示
      OPSList: [
        {id: 1, icon: require('@/assets/yy.png'), title: '全方位运营', text: '为客户提供全方位的系统集成及运维服务'},
        {id: 2, icon: require('@/assets/jcfw.png'), title: '集成服务', text: '硬件集成、软件集成、安全集成'},
        {id: 3, icon: require('@/assets/yjyy.png'), title: '运维服务', text: '现场技术服务、远程技术支持、运维托管服务'}
      ],
      hoverId: null,
      solutionArr: [
        {img: require('../assets/jjfa_01.jpg'),show: false,id: 1,text: '重点行业应用开发，例如：SaaS、PaaS、CRM、银行核心系统、监管报送平台、系统搭建、人工智能助理'},
        {img: require('../assets/jjfa_02.png'),show: false,id: 2,text: '通过开发系统实现更高效的线上营销、数据采集与标注、内容管理和营销、设计服务、本地化、智能客服、大数据分析等'},
        {img: require('../assets/jjfa_03.jpg'),show: false,id: 3,text: '大数据平台开发、商业智能、ERP云平台、智能终端、产品化解决方案'},
        {img: require('../assets/jjfa_04.jpg'),show: false,id: 4,text: '通过技术链接生活，打造全方位的收单营销生态体系，助力线下商户提供数字化转型'}
      ]    }
  },
  methods: {
    // 改变选择
    changeSe(index, sign) {
      // this.selected = index
      this.solutionsShow = false
      let anchorElementHeight = document.getElementById(sign).offsetTop; // 每个元素的高度
      let navBar = document.getElementById('navigationA').offsetHeight //固定导航的高度
      if (index == 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: anchorElementHeight - navBar,
          behavior: 'smooth'
        })
      }
    },
    // 移入事件
    mouseover(value) {
      this.mouseValue = value
    },
    // 移出事件
    mouseout() {
      this.mouseValue = null
    },
    // 继承与运维
    mouseOver(value) {
      this.hoverId = value
    },
    mouseOut() {
      this.hoverId = null
    },
    // 解决方案
    mouseoverSol(item){
      item.show = true
    },
    mouseoutSol(item){
      item.show = false
    },
    // 监听
    handleScroll() {
      //可滚动容器超出当前窗口显示范围的高度
      const navigationAHeight = parseInt(document.getElementById('navigationA').offsetHeight)  // 固定导航
      const scrollTop = parseInt((document.body.scrollTop || document.documentElement.scrollTop) + navigationAHeight);

      const digitizationTop = parseInt(document.getElementById('digitization').offsetTop) //公司介绍
      const solutionsTop = parseInt(document.getElementById('solutions').offsetTop) // 解决方案
      const outsourcingTop = parseInt(document.getElementById('outsourcing').offsetTop) // 人力资源服务
      const operationTop = parseInt(document.getElementById('operation').offsetTop) // 集成与运维
      const contactusTop = parseInt(document.getElementById('contactus').offsetTop) // 联系我们

      const isMobiel = this.isMobile()

      if (!isMobiel && scrollTop >= (solutionsTop - 300)) {  // 当到达解决方案时在显示
        this.solutionsShow = true
      }

      // 当滚动条小于公司介绍的距离顶部距离，下表改为首页
      if (scrollTop >= 0 && scrollTop < digitizationTop) {
        this.selected = 0
        if (!isMobiel) this.solutionsShow = false
      } else if (scrollTop >= digitizationTop && scrollTop < solutionsTop) {
        this.selected = 1
      } else if (scrollTop >= solutionsTop && scrollTop < outsourcingTop) {
        this.selected = 2
      } else if (scrollTop >= outsourcingTop && scrollTop < operationTop) {
        this.selected = 3
      } else if (scrollTop >= operationTop && scrollTop < contactusTop) {
        this.selected = 4
      } else if (scrollTop >= contactusTop) {
        this.selected = 5
      }
    },
    // 判断是否为移动端
    isMobile() {
      let plat = navigator.userAgent.match( // 判断不同端
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return plat != null;
    },
  },
  mounted() {
    const isMobiel = this.isMobile()
    this.isMobiel = isMobiel
    if (isMobiel) this.solutionsShow = true

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll); // 销毁监听
  },
}
</script>

<style lang="less" scoped>
.bigBox {
  width: 100%;
  //overflow-x: hidden;

  .navigation {
    width: 100%;
    min-height: 86px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index: 999;

    .left {
      width: 40%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 227px;
        height: 52px;
      }
    }

    .right {
      width: 60%;
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      margin-right: 182px;

      .item {
        font-size: 17px;
        font-family: Microsoft YaHei;
        padding: 15px 30px;
        margin-right: 5px;
        cursor: pointer;
      }

      .selected {
        background: #0790EA;
        color: #FFFFFF;
        border-radius: 2px;
      }
    }
  }

  .digitization {
    width: 100%;
    min-height: 935px;
    background: url('../assets/bg01.png') no-repeat;
    background-size: 100% 100%;
    padding-bottom: 30px;

    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 96px;
      position: relative;

      .en {
        font-size: 106px;
        font-family: Swis721 Blk BT;
        font-weight: 900;
        color: #FFFFFF;
        opacity: 0.3;
      }

      .zh {
        font-size: 56px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        position: absolute;
        top: 146px;
      }
    }

    .content {
      height: auto;
      margin-top: 100px;
      padding: 0 116px;
      display: flex;
      justify-content: space-around;

      .items {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .borderImg {
          width: 457px;
          height: 543px;
          position: absolute;
          top: -10px;
        }

        .borderImg2 {
          width: 477px;
          height: 543px;
          position: absolute;
          top: -10px;
        }

        .imgIcon {
          padding: 54px 0 42px;
        }

        .img1 {
          width: 97px;
          height: 85px;
        }

        .img2 {
          width: 93px;
          height: 87px;
        }

        .img3 {
          width: 82px;
          height: 82px;
        }

        .cont {
          width: 337px;
          height: 247px;
          font-size: 22px;
          font-family: SimHei;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 56px;
        }

        .w240 {
          width: 337px;
        }

        .w260 {
          width: 350px;
        }
      }
    }
  }

  .outsourcing {
    width: 100%;
    height: 967px;

    .title {
      padding-top: 108px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .en {
        font-size: 106px;
        font-family: Swis721 Blk BT;
        font-weight: 900;
        color: #DBDBDB;
        opacity: 0.6;
      }

      .zh {
        font-size: 56px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0260B7;
        position: absolute;
        top: 158px;
      }
    }
  }

  .solutions {
    width: 100%;

    .oneBox{
      min-height: 916px;
      background: #69A0F6;
      opacity: 0.8;

      .title {
        padding-top: 128px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .en {
          font-size: 106px;
          font-family: Swis721 Blk BT;
          font-weight: 900;
          color: #FFFFFF;
          opacity: 0.3;
        }

        .zh {
          font-size: 56px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #FFFFFF;
          position: absolute;
          bottom: 0px;
        }
      }

      .content {
        width: 100%;
        display: flex;
        justify-content: center;
        position: relative;
        height: 680px;

        .img_MacBook {
          width: 437px;
          height: 515px;
          margin-top: 60px;
        }

        .tit {
          font-size: 56px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #FFFFFF;
        }

        ul {
          margin-top: 46px;
          padding-left: 10px !important;
          line-height: 30px;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 42px;
        }

        .twoLine {
          margin-top: 30px;
        }

        .bankfinancial {
          position: absolute;
          top: 44px;
          left: 172px;
          width: 450px;
          color: #FFFFFF;
          p{
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 50px;
            margin: 0px;
          }
          .tit{
            font-size: 36px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
            margin-top: 15px;
          }
          //.cont {
          //  margin-top: 38px;
          //  font-size: 14px;
          //  font-family: Microsoft YaHei;
          //  font-weight: 300;
          //  color: #FFFFFF;
          //  line-height: 30px;
          //}

        }

        .internet {
          position: absolute;
          top: 44px;
          right: 181px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          width: 265px;
          .tit{
            width: 100%;
            font-size: 36px;
            font-family: Microsoft YaHei;
font-weight: bold;
color: #FFFFFF;
text-align: left;
          }
          .tit_t{
            width: 100%;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
            text-align: left;
            margin-top: 28px;
            margin-bottom: 5px;
          }
          ul{
            width: 100%;
            padding: 0px !important;
            margin: 0px !important;
            font-size: 24px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #FFFFFF;
line-height: 36px;
text-align: left;
          }
          //.cont {
          //  margin-top: 28px;
          //  font-size: 14px;
          //  font-family: Microsoft YaHei;
          //  font-weight: 300;
          //  color: #FFFFFF;
          //  line-height: 30px;
          //  text-align: right;
          //}
        }

        .servicelife {
          position: absolute;
          bottom: 102px;
          width: 410px;
          left: 172px;
        }

        .flex {
          display: flex;
          justify-content: space-between;

          .cont {
            width: 232px;
            height: 74px;
            margin-top: 38px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #FFFFFF;
            line-height: 30px;
          }
        }
      }
    }
    .Rpa_chunk{
      height: 916px;
      background: #E1ECFD;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      // align-items: center;
      .title{
        width: 500px;
        height: 56px;
        font-size: 56px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0260B7;
        line-height: 28px;
        padding-top: 56px;
        padding-left: 302px;
        margin-bottom: 10px;
      }
      .Rpa_img{
        width: 1318px;
        height: 714px;
        background: url('../assets/Rpa_img.png') no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
      }
    }
    .TwoBox{
      height: 916px;
      background: #E1ECFD;
      padding: 140px 165px 107px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;

      .items{
        width: 724px;
        height: 282px;
        background-size: 724px;
        background-position: center;
        background-repeat: no-repeat;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFEFE;

        .itemText{
          width: 100%;
          height: 100%;
          padding: 66px 125px;
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 60px;
          box-sizing: border-box;
          background: #71A7F0;
          opacity: .8;
        }
      }
    }
  }

  .operation {
    width: 100%;
    min-height: 939px;
    box-shadow: 0px 7px 41px 8px rgba(193, 193, 193, 0.49);

    .title {
      padding-top: 101px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .en {
        font-size: 106px;
        font-family: Swis721 Blk BT;
        font-weight: 900;
        color: #DBDBDB;;
        opacity: 0.6;
      }

      .zh {
        font-size: 56px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0260B7;;
        position: absolute;
        bottom: 0px;
      }
    }

    .content {
      margin-top: 141px;
      display: flex;
      align-items: flex-end;

      .left {
        width: 1131px;

        .noborder {
          border: none !important;
        }

        .hoverItem {

          img, .text, .titlei {
            transform: scale(1.1);
          }
        }

        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 203px;
          //padding: 48px 0;
          cursor: pointer;
          border-bottom: 1px solid #D5D5D5;
          box-sizing: border-box;

          .itemImg {
            width: 87px;
            height: 87px;
            margin-right: 74px;
          }

          .itemText {
            width: 573px;
            display: flex;
            flex-direction: column;

            .titlei {
              font-size: 30px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #2B2B2B;
            }

            .text {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #4C4C4C;
              line-height: 51px;
            }
          }
        }
      }

      .right {
        width: 789px;

        img {
          width: 789px;
          height: 592px;
        }
      }
    }
  }

  .contactus {
    width: 100%;
    min-height: 946px;
    background: #F8F8F8;

    .title {
      padding-top: 98px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .en {
        font-size: 106px;
        font-family: Swis721 Blk BT;
        font-weight: 900;
        color: #DBDBDB;;
        opacity: 0.6;
      }

      .zh {
        font-size: 56px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0260B7;;
        position: absolute;
        bottom: 0px;
      }
    }

    .content {
      display: flex;
      align-items: center;
      padding: 85px 297px 73px;

      img {
        width: 680px;
        height: 485px;
        margin-right: 116px;
      }

      .rightBox {
        height: auto;
        display: flex;
        width: 356px;
        height: 276px;
        flex-direction: column;

        .Name {
          font-size: 24px;
          font-weight: bold;
          color: #0260B7;
          line-height: 36px;
        }

        .value {
          font-size: 24px;
          color: #868686;
          margin-bottom: 25px;
        }
      }
    }
  }

  .footer {
    width: 100%;
    height: 99px;
    background: url('../assets/footer.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-family: SimSun;
    font-weight: 400;
    color: #FFFFFF;

    a {
      text-decoration: none;
      color: #FFFFFF;
      display: flex;
      align-items: center;
    }

    a:hover {
      opacity: .8;
    }

    .hao {
      font-size: 14px;
      margin-left: 20px;
    }
  }
}
</style>
<style scoped>
@keyframes leftForm {
  from {
    left: 0;
  }
  to {
    left: 172px;
  }
}

@keyframes rightForm {
  0% {
    right: -300px;
  }
  25% {
    right: -300px;
  }
  50% {
    right: -300px;
  }
  100% {
    right: 181px;
  }
}

@keyframes rightForm2 {
  0% {
    left: -300px;
  }
  50% {
    left: -300px;
  }
  100% {
    left: 172px;
  }
}

.Lfetto {
  animation: leftForm .3s;
}

.rightTo {
  animation: rightForm .9s;
}

.rightTo2 {
  animation: rightForm2 .6s;
}

.paddingCalc {
  padding-bottom: calc(50px + constant(safe-area-inset-bottom));
  /*兼容 IOS>11.2*/
  padding-bottom: calc(50px + env(safe-area-inset-bottom));
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue